import { useEffect, useState } from 'react';
import { Button, Spinner } from '@rnd-payplus/alloy-react';
import { KPICard } from '@rnd-payplus/alloy-react/patterns';
import { useAppSelector } from '../store';
import { usePageShell } from '../contexts/PageShellContext';

const DashboardPage = () => {
  const { currentTenant } = useAppSelector((state) => state.tenant);
  const [loading, setLoading] = useState(true);
  const [metrics, setMetrics] = useState({
    activeTenants: 0,
    activeConnections: 0,
    transactionsToday: 0,
    errorRate: 0,
  });

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await fetch('/dashboard/metrics');
        const data = await response.json();

        setMetrics({
          activeTenants: data.activeTenants || 0,
          activeConnections: data.activeConnections || 0,
          transactionsToday: data.transactionsToday || 0,
          errorRate: data.errorRate || 0,
        });
      } catch (error) {
        console.error('Failed to fetch metrics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
    const intervalId = setInterval(fetchMetrics, 30000);
    return () => clearInterval(intervalId);
  }, [currentTenant]);

  usePageShell({
    title: 'Dashboard',
    breadcrumbs: [
      { label: 'Home' },
    ],
  });

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[80vh]">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {/* KPI Metrics */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2.5">
        <KPICard title="Active Tenants" value={metrics.activeTenants} />
        <KPICard title="Active Connections" value={metrics.activeConnections} />
        <KPICard title="Transactions Today" value={metrics.transactionsToday} />
        <KPICard title="Error Rate" value={`${metrics.errorRate}%`} />
      </div>

      {/* Recent Activity & Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <h2 className="text-base font-medium leading-6 mb-4">Recent Activity</h2>
          <p className="text-sm text-muted-foreground">
            Activity feed will be displayed here with real-time updates via SignalR
          </p>
        </div>

        <div>
          <h2 className="text-base font-medium leading-6 mb-4">Quick Actions</h2>
          <div className="flex flex-col gap-2.5">
            <Button variant="outline">Manage Tenants</Button>
            <Button variant="outline">Add Integration</Button>
            <Button variant="outline">View Reports</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
